import PropTypes from 'prop-types';
import React from 'react';
import { ButtonSC, OptionsSwitcherSC } from './options-switcher.styled';

const OptionsSwitcher = ({ onChange, options, value }) => {
  return (
    <OptionsSwitcherSC>
      {options.map((opt) => (
        <ButtonSC type="button" onClick={() => onChange(opt)} isActive={value === opt} key={opt}>
          {opt}
        </ButtonSC>
      ))}
    </OptionsSwitcherSC>
  );
};

OptionsSwitcher.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default OptionsSwitcher;
